/**
 * @file project.tsx
 * @description Компонент страницы каталога проектов для управления сущностями проектов в системе управления 
 * задачами. Предоставляет функциональность создания, редактирования и просмотра проектов с поддержкой 
 * иерархической структуры проектов (отношения родитель-потомок). Включает простое табличное представление 
 * с колонками кода проекта, названия и родительского проекта для удобной организации и навигации.
 * @author AI Assistant
 * @created 2025-09-04
 * @updated 2025-09-04
 * @dependencies ['@forms/project', '@utils/table-view']
 * @related-files ['@forms/project/index.tsx']
 */

import { ProjectForm } from '@forms/project';
import { getDefaultCell } from '@utils/table-view';

export const title = 'Проекты';
export const searchModalTitle = 'Выбор проекта';
export const type = 'Project';
export const path = 'project';
export const form = ProjectForm;

export const columns = [
    {
        id: '$item',
        header: [{ text: 'Код' }],
        width: 120,
        render: (cellValue: any) => getDefaultCell(cellValue)
    },
    {
        id: 'name',
        header: [{ text: 'Наименование' }],
        render: (cellValue: any) => getDefaultCell(cellValue)
    },
    {
        id: 'parent',
        header: [{ text: 'Проект' }],
        render: (cellValue: any) => getDefaultCell(cellValue)
    }
];
